import {
  Component,
  Input,
  OnInit,
  ChangeDetectionStrategy,
} from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "up-confirm-modal",
  templateUrl: "./confirm-modal.component.html",
  styleUrls: ["./confirm-modal.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ConfirmModalComponent implements OnInit {
  @Input() action: string = "remover";
  @Input() message!: string;

  constructor(private _dialogRef: MatDialogRef<ConfirmModalComponent>) {}

  ngOnInit(): void {}

  close(): void {
    this._dialogRef.close(false);
  }

  confirm(): void {
    this._dialogRef.close(true);
  }
}
